export default __webpack_public_path__ + "static/share-21ada1c5d91984d6a024aa28f035bfcd.jpg";